import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IEncaissement, IEncaissementListCard } from '../../types/interfaces';
import UserEdit from '../user/UserEdit';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBalanceScaleLeft, faBuilding, faCheckCircle, faClipboard, faCommentAlt, faCreditCard, faCrown, faUniversity, faExclamationCircle, faExclamationTriangle, faExternalLinkAlt, faFunnelDollar, faHashtag, faMoneyBill, faMoneyCheck, faMoneyCheckAlt, faPen, faPhone, faQuestionCircle, faSave, faSignature, faSpinner, faSquare, faStore, faUser, faUserLock, faUsers, faWallet, faHandshake, faHandHoldingMedical, faKey } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { PRIVILEGE } from '../../types/privileges'
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const EncaissementListCardComponent = ({ 
  allRows,
  filteredRows,
  selectedProjet,
  hideFilterSwitch,
 }: IEncaissementListCard) => {
  const history = useHistory();
  const alert = useAlert();
  const [withFiltersValue, setWithFiltersValue] = useState(true);
  const [encaissements, setEncaissements] = useState<IEncaissement[]>([]);
  const sEncaissements = encaissements.reduce((e, t) => e + (t.MONTANT || 0), 0);
  const sParts = encaissements.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0);
  const cheques = encaissements.filter(e => e.MODE_REGL === constants.MODE_REGL_CHEQUE);
  const virements = encaissements.filter(e => e.MODE_REGL === constants.MODE_REGL_VIREMENT);
  const versements = encaissements.filter(e => e.MODE_REGL === constants.MODE_REGL_VERSEMENT);
  const unknownModeRegl = encaissements.filter(e => !e.MODE_REGL || ![constants.MODE_REGL_CHEQUE, constants.MODE_REGL_VERSEMENT, constants.MODE_REGL_VIREMENT].includes(e.MODE_REGL));

  useEffect(() => {
    if(withFiltersValue && !hideFilterSwitch)
      setEncaissements(filteredRows)
    else
      setEncaissements(allRows)
  }, [withFiltersValue, allRows, filteredRows])
  
  const changeWithFiltersHandle = (e) => {
    setWithFiltersValue(e.target.checked);
  };

  return (<>
    {encaissements?.length ? <Container className="CardInfo">
      <Row className="cardTitlesRow" style={{marginBottom: "0.5rem"}}>
        <Col xs="12" sm={hideFilterSwitch ? "12" : "6"} className="border-0">
          <h2 className="title">{selectedProjet?.id === "ALL" ? "Tous les projets" : (selectedProjet?.LIBELE || "-")}</h2>
        </Col>
        {!hideFilterSwitch && <Col xs="12" sm="6" className="venteCardSwitch justify-content-center justify-content-sm-end">
          <CustomInput type="switch" id="withFilters" name="withFiltersSwitch" label="Prendre en compte les filtres" checked={withFiltersValue} onChange={changeWithFiltersHandle} />
        </Col>}
      </Row>
      <Row>
        <Col xs="12" style={{textAlign: "center"}}>
          <h3>{encaissements.length} encaissements</h3>
        </Col>
      </Row>
      <Row className="justify-content-around">
        <Col xs="12" ms="6" lg={unknownModeRegl.length > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faMoneyCheck} />&nbsp;<strong>Chèques : </strong>{cheques.length} ({cheques.reduce((e, t) => e + (t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
        </Col>
        <Col xs="12" sm="6" lg={unknownModeRegl.length > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faCreditCard} />&nbsp;<strong>Virements : </strong>{virements.length} ({virements.reduce((e, t) => e + (t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
        </Col>
        <Col xs="12" sm="6" lg={unknownModeRegl.length > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faUniversity} />&nbsp;<strong>Versements : </strong>{versements.length} ({versements.reduce((e, t) => e + (t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
        </Col>
        {unknownModeRegl.length ? <Col xs="12" sm="6" lg="3" className="border-0 text-center">
          <FontAwesomeIcon icon={faQuestionCircle} />&nbsp;<strong>Inconnus : </strong>{unknownModeRegl.length} ({unknownModeRegl.reduce((e, t) => e + (t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
        </Col> : null}
      </Row>
      <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faMoneyCheckAlt} />&nbsp;<strong>Somme des encaissements : </strong>{sEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Somme des parts utilisées : </strong>{sParts.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH <span className="encPercent" style={{color: "hsl(" + (Math.ceil((sParts * 100) / sEncaissements) * 1.2).toString(10) + ", 100%, 50%)"}}>({Number(((sParts * 100) / sEncaissements).toFixed(2))}%)</span>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="12" md="6" lg="4" className="border-0 text-center">
          <FontAwesomeIcon icon={faHandshake} />&nbsp;<strong>Acompte réservation : </strong>{encaissements.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.TYPE_ECHEANCE === constants.TYPE_ECHE_ACOMPTE ? (t.PART || 0) : 0), 0) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
        <Col xs="12" md="6" lg="4" className="border-0 text-center">
          <FontAwesomeIcon icon={faHandHoldingMedical} />&nbsp;<strong>Recouvrement : </strong>{encaissements.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.TYPE_ECHEANCE === constants.TYPE_ECHE_RECOUVREMENT ? (t.PART || 0) : 0), 0) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
        <Col xs="12" md="6" lg="4" className="border-0 text-center">
          <FontAwesomeIcon icon={faKey} />&nbsp;<strong>Reliquat livraison : </strong>{encaissements.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.TYPE_ECHEANCE === constants.TYPE_ECHE_LIVRAISON ? (t.PART || 0) : 0), 0) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
      </Row>
    </Container> : null}
  </>);
};

export default connect(null, { })(EncaissementListCardComponent);
